import { useMemo } from 'react';
import { AUTH_STATE_STATUSES } from '../../../../authStateBar/authStateBar.common';

import { SENSOR_STATES } from '@linearb/linjs-common';
import useIsSensorSupportOAuth2 from 'common/hooks/auth/useIsSensorSupportOAuth2';
import { SENSOR_AUTH_TYPES } from 'common/services/sensors.service';
import { isSensorSupportScopesValidations } from 'views/oauth/scopes-validations/scopes-validations.utils';

const useAuthState = ({ sensor }) => {
  const isSupportOAuth2 = useIsSensorSupportOAuth2(sensor);
  const isOk = sensor?.state === SENSOR_STATES.ok;

  const authState = useMemo(() => {
    const authType = sensor?.profile?.auth_type;

    if (!sensor?.state) {
      return AUTH_STATE_STATUSES.NOT_CONNECTED;
    }

    if (authType !== SENSOR_AUTH_TYPES.OAUTH2 && isSupportOAuth2 && isOk) {
      return AUTH_STATE_STATUSES.UPGRADE_TO_OAUTH2;
    }

    if (isOk) {
      return AUTH_STATE_STATUSES.CONNECTED;
    }

    if (
      sensor?.state === SENSOR_STATES.inProgress &&
      isSensorSupportScopesValidations(sensor)
    ) {
      return AUTH_STATE_STATUSES.PENDING_VALIDATION;
    }

    if (
      sensor?.state === SENSOR_STATES['insufficient-permission'] &&
      isSensorSupportScopesValidations(sensor)
    ) {
      return AUTH_STATE_STATUSES.FAILURE_VALIDATION;
    }

    return AUTH_STATE_STATUSES.INACTIVE;
  }, [sensor, isSupportOAuth2]);

  return authState;
};

export default useAuthState;
